// @flow

import * as React from 'react';
import classnames from 'classnames';
import Box from 'sail/Box';
import './Video.scss';

type VideoProps = {|
  src: string,
  type: string,
  width?: number | string,
  height?: number,
  controls?: boolean,
  muted?: boolean,
  id?: string,
  className?: string,
  children?: React.Node,
|};

export const Video = ({
  src,
  type = 'video/mp4',
  width,
  height,
  controls,
  muted,
  id,
  className = '',
  children,
}: VideoProps) => {
  const videoProps = {
    width: width || '100%',
    height,
    muted,
    controls,
    playsInline: !controls,
    autoPlay: !controls,
    loop: !controls,
  };

  // In some browsers (e.g. Chrome 70.0) autoplay doesn't work if
  // no muted attribute is present.
  if (videoProps.autoPlay) {
    videoProps.muted = true;
  }

  return (
    <Box
      id={id}
      className={classnames('Video', className)}
      padding={{top: 32, bottom: 12}}
    >
      <video {...videoProps}>
        <source src={src} type={type} />
      </video>
      {children}
    </Box>
  );
};
